import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.slateGrey,
  errorColor: colors.warningRed
};
export default book;